import { Button } from '@radix-ui/themes';
import { SimpleCv } from '../types';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useDownloadSimpleCvPdf } from './useDownloadSimpleCvPdf';
import Cookies from 'js-cookie';
import ApiKey from 'Components/api/ApiKey';

export function DownloadSimpleCvPdf({ simpleCv }: { simpleCv: SimpleCv }) {
   const tokenKey = Cookies.get('tokenClient');
   const apiKey = ApiKey;

   const { onDownloadPdf, loadingPdf } = useDownloadSimpleCvPdf(simpleCv.id, {
      token: tokenKey ?? '',
      apiKey,
      onSuccess: (blob) => {
         const link = document.createElement('a');
         const url = URL.createObjectURL(blob);
         link.href = url;
         link.download = `${simpleCv.user_id}-${simpleCv.position}.pdf`;
         link.click();
         URL.revokeObjectURL(url);
      },
   });
   return (
      <Button size="4" radius="small" onClick={onDownloadPdf} loading={loadingPdf}>
         <FileDownloadOutlinedIcon />
         Завантажити PDF
      </Button>
   );
}
